import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ContactHero() {
  const { t } = useTranslation();

  return (
    <section className="relative bg-white pt-[72px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="http://geel.fp.08wx.cn/images/6a7757b3299e50c5c6bcb6e439561249.jpg"
          alt="Contact Hero"
          className="w-full h-full object-cover object-top opacity-12"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/70 via-white/50 to-white" />
        <div className="absolute inset-0 bg-gradient-to-r from-white/90 via-transparent to-white/90" />
      </div>

      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: 'linear-gradient(rgba(255,45,120,1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,45,120,1) 1px, transparent 1px)',
          backgroundSize: '60px 60px',
        }}
      />

      <div className="relative max-w-[1400px] mx-auto px-6 py-20 md:py-28">
        <div className="flex items-center gap-2 mb-8">
          <Link to="/" className="text-xs text-gray-400 hover:text-primary transition-colors">{t('breadcrumb.home')}</Link>
          <i className="ri-arrow-right-s-line text-gray-300 text-sm" />
          <span className="text-xs text-primary">{t('breadcrumb.contact')}</span>
        </div>

        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-12">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 mb-6 px-3 py-1.5 bg-primary/10 border border-primary/20 rounded-full">
              <span className="w-2 h-2 rounded-full bg-primary animate-pulse" />
              <span className="text-primary text-xs font-medium uppercase tracking-widest">{t('contact.hero.tag')}</span>
            </div>

            <h1 className="text-5xl md:text-6xl font-heading font-black text-gray-900 mb-5 leading-tight">
              {t('contact.hero.title')}
              <br />
              <span className="gradient-text">{t('contact.hero.highlight')}</span>
            </h1>

            <p className="text-gray-500 text-lg leading-relaxed max-w-xl">
              {t('contact.hero.desc1')}
              {t('contact.hero.desc2')}
            </p>
          </div>

          <div className="flex flex-col sm:flex-row lg:flex-col gap-3 lg:min-w-[240px]">
            {[
              { icon: 'ri-mail-send-line', label: t('contact.hero.card.0.label'), val: t('contact.hero.card.0.val'), color: '#FF2D78' },
              { icon: 'ri-customer-service-2-line', label: t('contact.hero.card.1.label'), val: t('contact.hero.card.1.val'), color: '#FF8C42' },
              { icon: 'ri-time-line', label: t('contact.hero.card.2.label'), val: t('contact.hero.card.2.val'), color: '#FF2D78' },
            ].map((item, i) => (
              <div key={i} className="flex items-center gap-3 px-4 py-3 bg-white border border-primary/15 rounded-xl">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg flex-shrink-0" style={{ background: `${item.color}12`, border: `1px solid ${item.color}25` }}>
                  <i className={`${item.icon} text-sm`} style={{ color: item.color }} />
                </div>
                <div>
                  <div className="text-xs text-gray-400">{item.label}</div>
                  <div className="text-sm font-medium text-gray-700">{item.val}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-white to-transparent pointer-events-none" />
    </section>
  );
}
